<template>
  <div class="form_container">
    <div class="form">
      <v-toolbar flat>
        <template v-slot:extension>
          <v-tabs v-model="data_local.type" centered>
            <v-tabs-slider color="#4B5EFF"></v-tabs-slider>
            <v-tab active-class="active_tab">
              Распознавание
            </v-tab>
            <v-tab active-class="active_tab">
              DTMF
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="data_local.type">
          <v-tab-item>
            <div class="answer_item">
              <v-expansion-panels v-model="panelOpenIdx">
                <draggable
                :easing="'cubic-bezier(.2,.7,.35,1)'"
                v-model="data_local.box"
                item-key="id"
                handle=".drag-handle"
                :draggable="'.v-expansion-panel'"
                :animation="200"
                ghost-class="dnd-ghost"
                chosen-class="dnd-chosen"
                drag-class="dnd-drag"
                @start="drag = true"
                @end="drag = false"
                @change="onDragChange"
                :component-data="{
                  tag:'transition-group',
                  type:'transition',
                  name: drag ? null : 'flip-list',
                  props:{ tag:'div' }
                }">
                <v-expansion-panel v-for="(itemP, i) in data_local.box" :key="itemP.id">
                  <div class="panel_container">
                    <div class="panel_head">
                      <v-expansion-panel-header :ref="`header-${i}`" :data-idx="i" class="anchor-header">
                        <template v-slot:actions>
                          <v-icon class="expand_icon" v-bind:class="{ system: itemP.items=='system' }">
                            $expand
                          </v-icon>
                        </template>
                        <v-icon class="drag-handle">mdi-drag</v-icon>
                        <div class="answer_key"  v-bind:class="{ system: itemP.items=='system' }">{{itemP.word}}</div>
                        <v-icon
                          v-if="panelOpenIdx === i"
                          class="sticky-up"
                          v-ripple="false"
                          @click.stop="scrollToHeader(i)"
                        >
                          mdi-arrow-up
                        </v-icon>
                        <v-icon
                          v-if="panelOpenIdx === i"
                          class="sticky-down"
                          v-ripple="false"
                          @click.stop="scrollToLastHeader"
                        >
                          mdi-arrow-down
                        </v-icon>
                      </v-expansion-panel-header>
                    </div>
                    <div class="actions">
                      
                      <template v-if="!systemIcon(itemP)">
                        <v-tooltip top transition="fade-transition">
                          <template v-slot:activator="{on,attrs}">
                            <div class="delete_icon" v-bind="attrs" v-on="on" @click.stop="renameAnswer(i)">
                              <Icon name="edit"/>
                            </div>
                          </template>
                          <span>Переименовать</span>
                        </v-tooltip>
                        
                        <v-tooltip top transition="fade-transition">
                          <template v-slot:activator="{on,attrs}">
                            <div class="delete_icon" v-bind="attrs" v-on="on" @click="exportKeywords(i)">
                              <Icon name="downloaad"/>
                            </div>
                          </template>
                          <span>Экспорт ключевых слов</span>
                        </v-tooltip>
                        <v-tooltip top transition="fade-transition">
                          <template v-slot:activator="{on,attrs}">
                            <div class="delete_icon" v-bind="attrs" v-on="on" @click="isImport = true; importTargetIdx = i; importDone = false; importReport = {added:[], dupLocal:[], dupGlobal:[]}; uploadedText=''">
                              <Icon name="upload"/>
                            </div>
                          </template>
                          <span>Импорт ключевых слов</span>
                        </v-tooltip>
                      </template>
                      <v-tooltip top transition="fade-transition">
                        <template v-slot:activator="{on, attrs}">
                          <div class="delete_icon" v-bind="attrs" v-on="on" @click="delete_keygen(data_local.box, i, $event)">
                            <Icon name="delete" />
                          </div>
                        </template>
                        <span>Удалить ответ</span>
                      </v-tooltip>
                    </div>
                    <transition name="fade">
                      <div v-if="isImport" class="import-layer" @click.self="isImport = false">
                        <transition name="scale">
                          <div class="import-modal" role="dialog" aria-modal="true">
                            <div class="import_header">
                              <h3 class="import_title">Импорт ключевых слов в блок <mark class="word">{{ data_local.box[importTargetIdx]?.word }}</mark></h3>
                              <button class="import_close" aria-label="закрыть" @click="isImport = false">
                                <Icon name="close"/>
                              </button>
                            </div>
                            <div class="import_content">
                              <div v-if="!importDone">
                              <v-radio-group v-model="importMode" class="mb-4">
                                <div class="infoemodzi">
                                  <v-radio label="Добавить к существующим" value="append" color="#4B5EFF"></v-radio>
                                  <v-tooltip right>
                                    <template #activator="{on,attrs}">
                                      <v-icon small color="gray" class="ml-2 info-icon" v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Ключевые слова из файла будут добавлены к текущим</span>
                                  </v-tooltip>
                                </div>
                                <div class="infoemodzi">
                                  <v-radio label="Полная замена" value="replace" color="#4B5EFF"></v-radio>
                                  <v-tooltip right>
                                    <template #activator="{on,attrs}">
                                      <v-icon small color="gray" class="ml-2 info-icon" v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Ключевые слова из файла полностью заменят текущие</span>
                                  </v-tooltip>
                                </div>
                              </v-radio-group>
                              <ImportDropzone accept=".txt,text/plain" :multiple="true" @uploaded="onUploaded" @error="$toast?.error?.($event)" />
                              <div class="import_actions">
                                <button type="button" class="btnInDropZone" :disabled="!uploadedText" @click.stop.prevent="runImport">Импорт</button>
                              </div>
                              </div>
                              <div v-else class="import-summary boxed">
                                <div v-if="importReport.added.length" class="success-banner"> <Icon name="ok"/>
                                  <div class="banner-content">
                                     <div class="banner-title">Успешно загружено:</div>
                                     <div class="banner-value"><b>{{ importReport.added.length }}</b>ключевых слов</div>
                                    </div>
                                    <button class="paste" @click="exportList('Успешно загруженные', importReport.added)"><Icon name="downloaad" /></button>
                                </div>
                                <div v-if="importMode==='append' && importReport.dupLocal.length" class="orange-banner"><Icon name="warning"/>
                                  <div class="banner-content">
                                    <div class="banner-title">Найдено в этом ответе блока:</div>
                                    <div class="banner-value"><b>{{ importReport.dupLocal.length }}</b> ключевых слов не загруженно</div>
                                  </div>
                                  <button class="paste" @click="exportList('В блоке', importReport.dupLocal)"><Icon name="downloaad" /></button>
                                </div>
                                <div v-if="importReport.dupGlobal.length" class="alert-banner">
                                <Icon name="alert1"/><div class="banner-content">
                                  <div class="banner-title">Найдено в других ответах блока:</div>
                                  <div class="banner-value"><b>{{ importReport.dupGlobal.length }}</b> ключевых слов не загруженно</div>
                                </div>
                                  <button class="paste" @click="exportList('Во всех блоках ', importReport.dupGlobal)"><Icon name="downloaad" /></button>
                                </div>
                                <div>
                                </div>
                              </div>
                               <div v-if="importDone" class="import_footer"><button class="btn1" @click="close_cb">Завершить</button></div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </transition>
                  </div>
                  <v-expansion-panel-content  v-if="itemP.items!='system'">
                    <div class="item_tab">
                      <div class="answers">
                        <div v-for="(item, j) in itemP.items" :key="j" class="item">
							<input
								@blur="blurWord(i,j)"
								@input="input"
								v-model="item.text"
								placeholder="Ответ"
								:style="{width: label_length(item) + 30 + 'px',
									color: validWord(item.text) ? '#000000' : '#ea1b1b'}"
								class="word_edit"
								:ref="`idInput${j}-${i}`"
								v-on:keyup.enter="add_word(itemP.items, i)"
							/>
							<div class="delete" @click="delete_word(itemP.items, j)">
                            <Icon name="close"/>
                          </div>
                        </div>
                        <div class="item add_item" @click="add_word(itemP.items, i)">
                          <Icon name="white_plus"/>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                </draggable>
              </v-expansion-panels>
            </div>
            <div class="add" ref="saveBlock">
              <div class="keygen_add" v-if="save_active">
                <v-text-field v-model="save_model" hide-details placeholder="Ключевое слово"></v-text-field>
              </div>
              <div class="btn_adder">
                <Icon name="blue_plus"/>
                <div class="text" v-if="save_active" @click="save_add">Сохранить</div>
              </div>
              <div class="text" v-if="!save_active" @click="save_activator">Добавить ответ</div>
            </div>
          </v-tab-item>  
          <v-tab-item>
            <div class="title">
              Ввод с телефона от 0 до 9
            </div>
          </v-tab-item>  
      </v-tabs-items>
<div class="seconds_wait">
<p>Ожидать ответа клиента секунд</p>
<v-slider
  max="60"
  min="1"
  track-fill-color="#4B5EFF"
  thumb-color="#4B5EFF"
  track-color="#AAABAD"
  color="#404247"
  hide-details
  v-model="data_local.seconds"
  thumb-label="always"
></v-slider>
    </div>
    </div>
  </div>
</template>

<script>
import ImportDropzone from '@/components/Table/ImportDropzone.vue'
import Icon from '../../../SetIcon.vue'
import draggable from 'vuedraggable'  
export default {
  props: ['data','edit_callback'],
  components: {
    Icon,ImportDropzone, draggable
  },
  methods:{
    
 onDragChange (evt) {
    const moved = evt?.moved
    const oldIndex = moved?.oldIndex
    const newIndex = moved?.newIndex
    if (oldIndex == null || newIndex == null || oldIndex === newIndex) return

    const host = this.getHost()
    if (!host) return

    try {
      const graph = JSON.parse(host.data.data || '{}')
      const nodeId   = this.data_local?.id
      const node     = graph?.[nodeId]
      if (!node || !Array.isArray(node.points)) return

      const hasTail = node.points.length === this.data_local.box.length + 1
      const tail    = hasTail ? node.points.pop() : undefined

      const movedPoint = node.points.splice(oldIndex, 1)[0]
      node.points.splice(newIndex, 0, movedPoint)

      if (hasTail) node.points.push(tail)

      node.data.box = this.data_local.box
      host.data.data = JSON.stringify(graph)
      this.edit_callback?.(this.data_local)
      if (this.panelOpenIdx === oldIndex) {
        this.panelOpenIdx = newIndex
      } else if (oldIndex < this.panelOpenIdx && newIndex >= this.panelOpenIdx) {
        this.panelOpenIdx -= 1
      } else if (oldIndex > this.panelOpenIdx && newIndex <= this.panelOpenIdx) {
        this.panelOpenIdx += 1
      }
    } catch (e) {
      console.log(e)
    }
  },

scrollToHeader(i) {
  this.panelOpenIdx = i;
  this.$nextTick(() => {
    const r = this.$refs[`header-${i}`];
    const n = Array.isArray(r) ? r[0] : r;
    const el = n?.$el || n;
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
},

scrollToLastHeader() {
  this.$nextTick(() => {
    this.$refs.saveBlock?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  })
},

getHost() {
  let p = this
  for (let i = 0; i < 6 && p; i++) {
    if (p?.data && typeof p.data.data === 'string') return p
    p = p.$parent
  }
  return null
},

    onUploaded(payload) {
    const parts = Array.isArray(payload) ? payload : [payload]
    const next = parts.map(t => String(t||'').trim()).filter(Boolean).join('\n')
    this.uploadedText = [this.uploadedText, next].filter(Boolean).join('\n')
    this.importDone = false
    this.importReport = { added: [], dupLocal: [], dupGlobal: [] }
  },

    normalizeWord(w){
      return String(w || '').trim().replace(/\s+/g,' ').toLowerCase()
    },

    parseKeywordsFromText(txt){
      return String(txt || '').split(/[,\n;\t|.]+|…/).map(s => s.replace(/^['"]|['"]$/g,'').trim()).filter(s => s && !s.startsWith('#') && !s.startsWith('//'));
    },

    allOtherKeywordsSet(exceptIdx) {
  const set = new Set();
  this.data_local.box.forEach((g, idx) => {
    if (idx === exceptIdx) return;
    if (!Array.isArray(g.items)) return;
    g.items.forEach(it => set.add(this.normalizeWord(it.text)));
  });
  return set;
},

currentKeywordsSet(idx) {
  const set = new Set();
  const g = this.data_local.box[idx];
  if (Array.isArray(g?.items)) {
    g.items.forEach(it => set.add(this.normalizeWord(it.text)));
  }
  return set;
},

runImport() {
  if (!this.isImport || this.importTargetIdx == null) return;
  const g = this.data_local.box[this.importTargetIdx];
  if (!g || g.items === 'system') return;

  const fromFile = this.parseKeywordsFromText(this.uploadedText);
  const otherSet = this.allOtherKeywordsSet(this.importTargetIdx);
  let currSet = this.currentKeywordsSet(this.importTargetIdx);

  const added = [];
  const dupLocal = [];
  const dupGlobal = [];

  if (this.importMode === 'replace') {
    g.items = [];
    currSet = new Set();
  }

  for (const raw of fromFile) {
    const norm = this.normalizeWord(raw);
    if (!norm) continue;

   if (currSet.has(norm)) {
  dupLocal.push(raw);
  continue;
}

    if (otherSet.has(norm)) {
      dupGlobal.push(raw);
      continue;
    }

    if (!Array.isArray(g.items)) g.items = [];
    g.items.push({ text: raw.trim() })
    currSet.add(norm);
    added.push(raw.trim());
  }

  this.importReport = { added, dupLocal, dupGlobal };
  this.edit_callback(this.data_local);
  this.importDone = true
},


    close_cb() {
			this.isImport=false; this.uploadedText=''; this.importDone=false; this.importReport={added:[],dupLocal:[],dupGlobal:[]}
		},

    exportKeywords(groupIdx){
      const g = this.data_local.box[groupIdx]
      if(!Array.isArray(g.items)) return
      const lines = g.items.map(it => (it?.text ?? '').trim()).filter(Boolean)
      const content = lines.join('\n')+'\n'
      const blob = new Blob([content], { type:'text/plain;charset=utf-8'})
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = `${(g.word || 'keywords')}.txt`
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(a.href)
    },

    exportList(fileBase, list){
      if (!Array.isArray(list) || !list.length) return;
      const lines = list.map(s => String(s || '').trim()).filter(Boolean)
      const content = lines.join('\n') + '\n'
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = `${fileBase || 'keywords'}.txt`
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(a.href)
    },
    systemIcon(itemP){
      return itemP?.items === 'system'
    },

	validWord(textVal) {

		// тут мы разворачиваем все группы слов в один плоский масив, вынимаем с них текст,
		// фильтруем по слову которое проверяем проверяем на дубли, если совпадений не равно 1 тогда фолс
		return this.data_local.box.reduce((rslt, current) => Array.isArray(current.items)?[...rslt, ...current.items]:rslt, [])
				.map(item => item.text)
				.filter(w => w === textVal)
				.length === 1
	},
	blurWord(group, item){
		if (this.data_local.box[group].items[item]){
			let newWord = this.data_local.box[group].items[item].text.trim()
			if(newWord.length){
				this.data_local.box[group].items[item].text = newWord
			} else this.data_local.box[group].items.splice(item,1);
		}
	},
    label_length(item)
    {
      let length=10*item.text.length
      if (length<50)
      {
      length=50
      }
      return length + 20
    },
    input()
    {
        this.edit_callback(this.data_local)
        return true
    },
   save_add()
    {
      if (this.save_model.length>0)
      {
        this.save_active=false
        this.data_local.box.push({
          word:this.save_model,
          items:[{"text":this.save_model}]
        });
        this.save_model=''
        this.input()
      }
    },

    save_activator()
    {
      this.save_active=true
    },
    delete_keygen(array,j,event)
    {
      event.preventDefault()
      array.splice(j, 1)

      this.input()
      return false;
    },
    delete_word(array,j)
    {
    array.splice(j, 1);
    },
add_word(array, numFor)
    {
		//console.log(array.length)
		if(array.length === 0 || array[array.length - 1].text){
			array.push({text:""})
			setTimeout(() => {
				for(let i of [1,1]){
					this.$refs[`idInput${array.length - i}-${numFor}`][0].focus();
				}
			}, 10)
		}
    },

    word_editor(item)
    {
      item.word_edit=true
      this.edit_item=item.text
    },
    renameAnswer(i) {
  const g = this.data_local.box[i]
  if (!g) return
  const oldWord = String(g.word || '').trim()
  const val = window.prompt('Новое название ответа', oldWord)
  if (val == null) return
  const newWord = String(val).trim()
  if (!newWord || newWord === oldWord) return

  g.word = newWord

  if (Array.isArray(g.items) && g.items.length) {
    const first = g.items[0]
    if (String(first.text || '').trim().toLowerCase() === oldWord.toLowerCase()) {
      first.text = newWord
    }
  }

  this.input() // у тебя дергает edit_callback(this.data_local)
}
  },
  watch: {
    data: function (val) {
      this.data_local=val
    },
  },
  mounted()
  {
    this.data_local=this.data
    const ensureId = obj => (obj.id ? obj.id : (obj.id = '_' + Math.random().toString(36).slice(2,9)))
    if (Array.isArray(this.data_local?.box)) {
    this.data_local.box.forEach(ensureId)
  }
  },
  data(){
    return {
      panelOpenIdx: null,
      drag: false,
      importDone: false,
      importMode: 'append',
      importTargetIdx: null,
      uploadedText: '',
      importReport: { 
             added: [],
             dupLocal: [],
             dupGlobal: [] 
},
      isImport: false,
      model:0,
      slider:0,
      word_edit:false,
      tester:true,
      save_model:'',
      save_active:false,
      edit_item:'',
      answers: [],
      template_answers: [
        'Нет', 'Да', 'Повторите', 'Отстаньте', 'Не хочу', 'Не нужно', 'Не интересует', 'Продолжайте'
      ],
    tab: null,
    data_local:[],
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      tabs: ['Выбрать готовые', 'Сделать самостоятельно'],
      tab_items: [
        { title: 'Текст реплики робота', vs: 'Создать реплику'},
        { title: 'Текст реплики робота', vs: 'Загрузить аудиозапись'}
      ],
    }
  }
}
</script>

<style scoped>
.infoemodzi:first-child{ margin-top: 5px; }
.word{
  vertical-align: text-bottom;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  background:#4B5EFF;
  color:#eee ; 
  padding:4px 9px 4px 9px ; 
  border-radius:8px;
 }
:deep(.flip-list-move){
  transition: transform .45s cubic-bezier(.2,.7,.35,1);
  will-change: transform;
}
:deep(.dnd-ghost){ opacity:.45; background:#F7FBFF; }
:deep(.dnd-chosen){ box-shadow:0 8px 22px rgba(0,0,0,.18); }
.sticky-down{ 
  position: fixed;
  right: 30px;
  bottom: 26px;
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4B5EFF;
  color: #fff;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
  z-index: 9999;
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;
  will-change: transform;
}
.sticky-up{
  position: fixed;
  right: 30px;
  bottom: 76px;
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4B5EFF;
  color: #fff;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
  z-index: 9999;
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;
  will-change: transform;
}
.sticky-up:hover,
.sticky-down:hover{
  transform: scale(1.12);
  box-shadow: 0 8px 22px rgba(0,0,0,.28);
}

.sticky-up:active,
.sticky-down:active{
  transform: scale(0.96);
}
:deep(.anchor-header){ scroll-margin-top: 72px; }
:deep(.v-expansion-panel-header){
  position: relative;
  padding-left: 28px;
}

.drag-handle{
  position: absolute;
  left: -23px;
  top: 40%;
  transform: translateY(-50%);
  cursor: grab;
  user-select: none;
}
.drag-handle:active{ cursor: grabbing; }
/* Тут все что связанно с модалкой */
.success-banner, .orange-banner, .alert-banner { gap: 10px; }
.success-banner > .icon, .orange-banner > .icon, .alert-banner > .icon { margin-top: 2px; }
.paste {
  margin-left: auto;
  background: transparent;
  border: none;
  cursor: pointer;
}

.banner-content { display: grid; gap: 4px; }
.banner-title { font-weight: 700; line-height: 1.2; }
.banner-value { line-height: 1.2; }
.alert-banner{
  display: flex;
  align-items: flex-start;
  background: rgb(248, 184, 184);
  border-radius: 4px;
  padding: 12px 16px;
  color: #1F3C44;
}
.orange-banner{
  display: flex;
  align-items: flex-start;
  background: rgb(252, 230, 192);
  border-radius: 4px;
  padding: 12px 16px;
  color: #1F3C44;
}
.success-banner{
  display: flex;
  align-items: flex-start;
  background: #CFF5D2;
  border-radius: 4px;
  padding: 12px 16px;
  color: #1F3C44;
}
.import-summary.boxed{
  border: none;
  border-radius: 12px;
  padding: 12px 14px;
  background:#FFF;
  display: grid;
  gap: 10px;
}
.import_footer{
  margin-top: auto;
  border-top: 1px solid #F0F2F5;
  padding:16px 24px;
  background:#fff;
  display:flex; justify-content:center;
}
.import_footer .btn1 {
  padding: 10px 20px;
  background: #fff;
  border: 1px solid #4B5EFF;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
}
.btn1{
  padding: 10px 20px; background: #fff; border: 1px solid #4B5EFF;
  border-radius: 8px; font-weight: 700; cursor: pointer;
}
.import-layer{
  position: fixed;
  inset: 0;
  background: rgba(151, 151, 151, 0.171);
  display: grid;
  place-items: center; 
  z-index: 5; 
}
.import-modal{
  display:flex; flex-direction:column;
  width: 495px;
  height: 490px;
  max-width: calc(100vw - 48px);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.import_header{
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 18px 20px 6px;
}
.import_title{
  grid-column: 2;
  justify-self: center;
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
}
.import_close{
  grid-column: 3;
  justify-self: end; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.import_content{ 
   flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow:auto;
  padding: 4px 24px 20px;
   }

.dropzone{
  border: 2px dashed #C9D6DF;
  background: #F7FBFF;
  border-radius: 8px;
  padding: 20px;
  margin: 12px 0 20px;
}
.btnInDropZone{
  display: block;
  width: 100%;
  text-align: center;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 800;
  background: #4B5EFF;
  border: 1px solid #4B5EFF; 
  border-radius: 10px;
  color: #eee;
  cursor: pointer;
}
.infoemodzi{
  display: flex;
  align-items: center;
}
.info-icon {
  position: relative;
  top: -4px;
  cursor: pointer;
}
.import_actions{
  display:flex; justify-content:center; gap:12px; margin-top: 8px;
}
/* конец модальки дальше старый код */
.actions{
  display: flex;
}
.title{
  margin-top: 20px;
}
.seconds_wait
{
  margin-top: 25px;
  text-align: left;
}
.seconds_wait p
{
  margin-bottom: 40px;
}
.keygen_add
{
  margin-right: 30px;
  width: 100%;
}
.panel_container
{
  display: flex;
}
.panel_head
{
  width:100%;
}
.v-expansion-panel::before
{
box-shadow: none!important;
background: none!important;
}
.expand_icon
{
position: absolute;
top:calc(50% - 20px);
right:10px;
}
.expand_icon.system
{
display: none;
}
.v-expansion-panel
{
  background: none!important;
}
.v-expansion-panel-header
{
background: none;
padding: 0px;
padding-bottom: 15px;
}
.word_edit
{
  text-align: center;
	border: 1px solid #cccccc;
	background: #F4F4F4;
	border-radius: 24px;
	padding: 9px 20px;
}
.btn_adder{
  display: flex;
  align-items: center;
}
.word_edit:focus
{
	border: 1px solid #cccccc;
	background: none;
	border-radius: 5px;
}

.word_edit:hover
{
	border: 1px solid #8d8d8d;
	background: #ffffff;
}

.answers
{
text-align: left;
line-height: 24px;
display: flex;
align-items: center;
flex-wrap: wrap;
}
.answers .word_span
{
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 20px;
  padding-right: 20px;
}
.answers .item.add_item
{
  background: #4B5EFF;
  color: #eee;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.item{
  /*padding: 9px 20px;*/
}
.item:hover{
	background: none;
}
.answers .item
{
display:inline-block;
position:relative;

margin-right: 7px;
margin-top: 5px;
margin-bottom: 5px;

}

.add_item{
	background: #F4F4F4;
	border-radius: 24px;
}
.answers .item .delete
{
  display:none;
}

.answers  .item:hover .delete
{
  position: absolute;
  top:-2px;
  display:block;
  right: -2px;
}
.v-toolbar__content
{
height: 15px; /* 15px */
}
.v-tab
{
  font-size: 17px;
  color: #2B2D33;
  text-align: left;
  padding-left:5px;
  font-style: normal;
  text-transform: none !important;
  padding-right: 20px;
  line-height: 20px;
}
.answer_lib
{
background: #FFFFFF;
box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.1);
border-radius: 6px;
min-height:168px;
padding-left: 12px;
padding-top: 16px;
padding-right: 12px;
padding-bottom: 12px;
margin-top: 10px;
}
.answer_key
{
width: 480px;
height: 48px;
cursor:pointer;
background: #FFFFFF;
border: 1px solid #AAABAD;
padding-left: 12px;
text-align: left;
color: #2B2D33;
font-size: 17px;
line-height: 48px;
border-radius: 8px;
}
.answer_key.system
{
  background: #f5f5f5;
  width: 580px;
  height: 48px;
}
.answer_item
{
  display: flex;
  width: 100%;
  max-width: 770px;
  margin-top: 15px;
}
.delete_icon
{
  width: 48px;
  height: 48px;
    cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  border: 1px solid #4B5EFF;
  border-radius: 8px;
  display: flex;
}
.form
{
display: inline-block;
/*margin-top:32px;*/
max-width: 900px; 
width: 780px;
}
.form_container
{
  text-align: center;
  width: 100%;
}
.subtitler{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #55575C;
}
.add{
  cursor: pointer;
  display: flex;
  color: #4B5EFF;
  align-items: center;
}
.add .icon{
  margin-right: 10px;
}
.btn_unlock{
  font-style: normal;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  margin-bottom: 19px;
  font-size: 15px;
  line-height: 120%;
  color: #4B5EFF;
}
.row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 0 0!important;
}
.my_input{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #808185;
  position: relative;
}

.my_input:active, :hover, :focus {
    outline: 0;
    outline-offset: 0;
}
.my_input .icon{
  position: absolute;
  right: 7px;
  top: 17px;
}
.subtitle{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin-bottom: 6px;
}
.modal_header{
  display: flex;
  align-self: flex-end;
}
.item_tab{
  margin: 0;
  max-width: 600px;
}
.modal_body{
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}
.save{
  padding: 10px 20px 12px;
  background: #4B5EFF;
  border-radius: 8px;
  margin: 16px 0 0 0;
}
.modal_title{
margin-top: 32px;
margin-bottom: 8px;
}
h3{
  margin-bottom: 12px;
  text-align: left;
}
.close{
  margin-right: 52px;
  margin-top: 20px;
}
</style>
